export default class MasterCompetencyMappingList {
    constructor({ positionId: cid, positionName: name, schemes: scheme }) {
        this.positionId = cid;
        this.positionName = name;
        this.schemes = scheme;
    }
}
